import {connect} from '@modifi/redux'
import {FeInputFieldStatus, ProductType, Currency, CurrencyVal} from '@modifi/enums'
import {selectCountries} from '@modifi/plugin-countries'

import BuyerFormContent, {BuyerFormContentProps} from './BuyerFormContent'
import {
  selectCanUpdateSellerTradePartnerDataInfo,
  selectCanUpdateTradePartnerCompanyDetails,
  selectSellerTradePartnersCount,
} from '../../../../../../data/seller-trade-partners'
import {selectCompanyExternalId, selectCompanyIsLocked} from '../../../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../../../modules/input-fields'
import {SECTION_SELLER_TRADE_PARTNERS} from '../../../../../../constants/sections'
import {selectBuyerId} from '../../store/view'
import {
  aEnsureLegalFormsByCountryCode,
  selectLegalFormsByCountryCode,
} from '../../../../../../data/legal-forms'
import {selectFinancingCurrenciesByProductType} from '../../../../../../data/currencies'
import {selectCurrencyConversionRate} from '../../../../../../data/exchange-rate'

const getRiskCountries = (countries: Record<string, any>[], riskLevel: string): string[] =>
  countries
    ?.filter(country => country?.buyerRiskLevel === riskLevel)
    .map(country => country.alpha2) as string[]

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  BuyerFormContentProps,
  | 'externalTradePartnerId'
  | 'highBuyerRiskCountries'
  | 'canUpdateTradePartnerCompanyDetails'
  | 'isTradePartnerDataInfoReadOnly'
  | 'getLegalForms'
  | 'mediumBuyerRiskCountries'
  | 'financingCurrencies'
  | 'getConversionRate'
  | 'buyerCount'
  | 'externalCompanyId'
> => {
  const externalTradePartnerId = selectBuyerId(state)
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_SELLER_TRADE_PARTNERS) ===
    FeInputFieldStatus.VERIFIED

  const countries = selectCountries(state)
  return {
    externalCompanyId: selectCompanyExternalId(state) || '',
    externalTradePartnerId,
    highBuyerRiskCountries: getRiskCountries(countries, 'HIGH'),
    mediumBuyerRiskCountries: getRiskCountries(countries, 'MEDIUM'),
    canUpdateTradePartnerCompanyDetails: externalTradePartnerId
      ? selectCanUpdateTradePartnerCompanyDetails(state, externalTradePartnerId)
      : true,
    isTradePartnerDataInfoReadOnly: externalTradePartnerId
      ? companyIsLocked ||
        isVerified ||
        !selectCanUpdateSellerTradePartnerDataInfo(state, externalTradePartnerId)
      : false,
    getLegalForms: (countryCode: string): string[] =>
      selectLegalFormsByCountryCode(state, countryCode),
    financingCurrencies:
      selectFinancingCurrenciesByProductType(state, ProductType.SELLER_FINANCING) || [],
    getConversionRate: (expectedFinancingLimitCurrency: CurrencyVal): number =>
      selectCurrencyConversionRate(state, expectedFinancingLimitCurrency, Currency.USD),
    buyerCount: selectSellerTradePartnersCount(state),
  }
}

const mapDispatchToProps = {
  fetchLegalForms: aEnsureLegalFormsByCountryCode,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerFormContent)
